// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumbs_root__O4BY4","separator":"Breadcrumbs_separator__etls7","label":"Breadcrumbs_label__QtZaQ","link":"Breadcrumbs_link___lxAf"};